import { Player$PlaylistMode } from '@Ravnur-Inc/player/src/types/Playlist';
import { stringify } from 'qs';

const EMBED_MEDIA_PAGE_PATH = 'embed/media/';
const EMBED_CATEGORY_PAGE_PATH = 'embed/category';

type Embed$Styles = {
  width: string;
  height: string;
};

export type Embed$SingleOptions = {
  mediaId: string;
  autoStart: boolean;
  showAnnotations: boolean;
  from: number | null;
  to: number | null;
  muted: boolean;
  loop?: boolean;
};

export type Embed$PlaylistOptions = {
  playlistId: string;
  autoStart: boolean;
  showAnnotations: boolean;
  playlistMode: Player$PlaylistMode;
  hidePlaylist: boolean;
  muted: boolean;
  loop: boolean;
};

export type Embed$CategoriesOptions = {
  categoriesIds: string[];
  playlistMode: Player$PlaylistMode;
  bdate: Nullable<string>;
  edate: Nullable<string>;
  muted: boolean;
  autostart: boolean;
};

export function getEmbedForPlaylist(
  host: string,
  styles: Embed$Styles,
  options: Embed$PlaylistOptions
) {
  const { playlistId, autoStart, showAnnotations, playlistMode, muted, loop, hidePlaylist } =
    options;
  const params: Dictionary<string> = {
    listposition: playlistMode === 'right' ? '0' : '1',
    autostart: autoStart ? '1' : '0',
    showann: showAnnotations ? '1' : '0',
    hideplaylist: hidePlaylist ? '1' : '0',
    muted: muted ? '1' : '0',
    loop: loop ? '1' : '0',
  };
  const path = EMBED_MEDIA_PAGE_PATH + playlistId;
  return _getEmbed(host, path, params, styles);
}

export function getEmbedForCategories(
  host: string,
  styles: Embed$Styles,
  options: Embed$CategoriesOptions
) {
  const { categoriesIds, playlistMode, edate, bdate, muted, autostart } = options;
  const params: Dictionary<string | string[]> = {
    categoryIds: categoriesIds,
    listposition: playlistMode === 'right' ? '0' : '1',
    muted: muted ? '1' : '0',
    autostart: autostart ? '1' : '0',
  };
  if (bdate) {
    params.bdate = bdate;
  }
  if (edate) {
    params.edate = edate;
  }
  return _getEmbed(host, EMBED_CATEGORY_PAGE_PATH, params, styles);
}

export function getEmbedForSingleMedia(
  host: string,
  styles: Embed$Styles,
  options: Embed$SingleOptions
) {
  const { mediaId, autoStart, showAnnotations, from, to, muted, loop } = options;
  const params: Dictionary<string> = {
    autostart: autoStart ? '1' : '0',
    showann: showAnnotations ? '1' : '0',
    muted: muted ? '1' : '0',
    loop: loop ? '1' : '0',
  };
  if (from) {
    params.start = `${from}`;
  }
  if (to) {
    params.stop = `${to}`;
  }

  const path = EMBED_MEDIA_PAGE_PATH + mediaId;
  return _getEmbed(host, path, params, styles);
}

function _getEmbed(
  host: string,
  path: string,
  params: Dictionary<string | string[]>,
  styles: Embed$Styles
): string {
  const url = host + path;
  const s = `width: ${styles.width}; height: ${styles.height};`;
  const rp = stringify(params, { arrayFormat: 'repeat' });
  const props = `scrolling="no" style="${s}" allowfullscreen="true" frameborder="0" seamless`;
  return `<iframe src="${url}?${rp}" ${props}></iframe>`;
}
